<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <!-- Sistema de pestañas de Element Plus -->
        <el-tabs v-model="activeTab" class="mb-4">
          <el-tab-pane label="Panel Conexiones" name="conexiones">
            <!-- Tarjetas de estadísticas -->
            <div class="row">
              <div class="col-xl-4 col-sm-6 mb-xl-0 mb-4">
                <mini-statistics-card
                  title="Conexiones Idle"
                  :value="isLoading ? 'Cargando...' : formatCurrency(dashboardData.totalProyectos)"
                  :percentage="{
                    value: dashboardData.porcentajeProyectos || '+0%',
                    color: dashboardData.porcentajeProyectos?.startsWith('+') ? 'text-success' : 'text-danger'
                  }"
                  :icon="{
                    component: 'ni ni-money-coins',
                    background: iconBackground
                  }"
                  direction-reverse
                />
              </div>
              <div class="col-xl-4 col-sm-6 mb-xl-0 mb-4">
                <mini-statistics-card
                  title="Conexiones Activas"
                  :value="isLoading ? 'Cargando...' : dashboardData.totalSubproyectos.toString()"
                  :percentage="{
                    value: dashboardData.porcentajeSubproyectos || '+0%',
                    color: dashboardData.porcentajeSubproyectos?.startsWith('+') ? 'text-success' : 'text-danger'
                  }"
                  :icon="{
                    component: 'ni ni-world',
                    background: iconBackground
                  }"
                  direction-reverse
                />
              </div>
              <div class="col-xl-4 col-sm-6 mb-xl-0">
                <mini-statistics-card
                  title="Total Conexiones"
                  :value="isLoading ? 'Cargando...' : dashboardData.totalObras.toString()"
                  :percentage="{
                    value: dashboardData.porcentajeObras || '+0%',
                    color: dashboardData.porcentajeObras?.startsWith('+') ? 'text-success' : 'text-danger'
                  }"
                  :icon="{
                    component: 'ni ni-paper-diploma',
                    background: iconBackground
                  }"
                  direction-reverse
                />
              </div>
            </div>

            <!-- Primera fila con dos secciones -->
            <div class="row mt-4">
              <!-- Sección 1: Registros superiores al 80% de MAX conexiones -->
              <div class="col-lg-6 mb-4">
                <div class="card">
                  <div class="card-header pb-0">
                    <h6>Registros superiores al 80% de MAX conexiones registradas</h6>
                  </div>
                  <div class="card-body p-3">
                    <div class="chart-container position-relative" style="height: 300px; width: 100%;">
                      <div v-if="isLoading" class="d-flex justify-content-center align-items-center h-100">
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">Cargando...</span>
                        </div>
                      </div>
                      <canvas v-else ref="highConnectionChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Sección 2: Evolución de Conexiones Recientes -->
              <div class="col-lg-6 mb-4">
                <div class="card">
                  <div class="card-header pb-0">
                    <h6>Evolución de Conexiones Recientes</h6>
                  </div>
                  <div class="card-body p-3">
                    <div class="chart-container position-relative" style="height: 300px; width: 100%;">
                      <div v-if="isLoading" class="d-flex justify-content-center align-items-center h-100">
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">Cargando...</span>
                        </div>
                      </div>
                      <canvas v-else ref="connectionTrendsChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Segunda fila con una sección -->
            <div class="row">
              <!-- Sección 3: Total Conexiones Recientes -->
              <div class="col-12">
                <div class="card">
                  <div class="card-header pb-0">
                    <h6>Total Conexiones Recientes (últimos 30 días)</h6>
                  </div>
                  <div class="card-body p-3">
                    <div class="chart-container position-relative" style="height: 400px; width: 100%;">
                      <div v-if="isLoading" class="d-flex justify-content-center align-items-center h-100">
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">Cargando...</span>
                        </div>
                      </div>
                      <canvas v-else ref="recentConnectionsChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          
          <!-- Pestaña de automatizaciones -->
          <el-tab-pane label="Panel Automatizaciones" name="automatizaciones">
            <!-- Código original para automatizaciones -->
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import Chart from 'chart.js/auto';
import axios from 'axios';

export default {
  name: "tables",
  components: {
    MiniStatisticsCard
  },
  data() {
    return {
      activeTab: 'conexiones',
      isLoading: false,
      iconBackground: 'gradient-primary',
      dashboardData: {
        totalProyectos: 0,
        porcentajeProyectos: '+0%',
        totalSubproyectos: 0,
        porcentajeSubproyectos: '+0%',
        totalObras: 0,
        porcentajeObras: '+0%'
      },
      highConnectionData: [],
      highConnectionChart: null,
      connectionTrendsData: [],
      connectionTrendsChart: null,
      recentConnectionsData: [],
      recentConnectionsChart: null,
      // Si bien en la pestaña de automatizaciones antes se usaban datos simulados,
      // ahora se espera que vengan del controlador.
      cronLinuxSummary: [],
      cronAccessSummary: [],
      cronLinuxAutomatismos: [],
      cronAccessAutomatismos: [],
      maxCronLinuxValue: 100,
      maxCronAccessValue: 100
    };
  },
  methods: {
    formatCurrency(value) {
      return value.toString();
    },
    loadDashboardData() {
      this.isLoading = true;
      
      console.log('Intentando obtener datos de la API...');
      
      // Obtener estadísticas de conexiones desde la API
      axios.get('/api/v2/estadisticas-conexiones')
        .then(response => {
          console.log('Respuesta de la API (estadísticas):', response.data);
          if (response.data) {
            this.dashboardData = response.data;
            console.log('Estadísticas de conexiones actualizadas:', this.dashboardData);
          } else {
            console.warn('La API devolvió un formato inesperado para estadísticas');
          }
        })
        .catch(error => {
          console.error('Error cargando estadísticas de conexiones:', error);
        });
      
      // Obtener datos de conexiones críticas desde la API
      axios.get('/api/v2/conexiones-criticas')
        .then(response => {
          console.log('Respuesta de la API (conexiones críticas):', response.data);
          if (response.data && response.data.length > 0) {
            this.highConnectionData = response.data;
            console.log('Datos guardados en highConnectionData:', this.highConnectionData);
            setTimeout(() => {
              this.createHighConnectionChart();
            }, 100);
          } else {
            console.warn('La API devolvió un array vacío o un formato inesperado para conexiones críticas');
          }
        })
        .catch(error => {
          console.error('Error cargando datos de conexiones críticas:', error);
        });
      
      // Obtener datos de evolución de conexiones desde la API
      axios.get('/api/v2/evolucion-conexiones')
        .then(response => {
          console.log('Respuesta de la API (evolución conexiones):', response.data);
          if (response.data && response.data.length > 0) {
            this.connectionTrendsData = response.data;
            console.log('Datos guardados en connectionTrendsData:', this.connectionTrendsData);
            setTimeout(() => {
              this.createConnectionTrendsChart();
            }, 100);
          } else {
            console.warn('La API devolvió un array vacío o un formato inesperado para evolución de conexiones');
          }
        })
        .catch(error => {
          console.error('Error cargando datos de evolución de conexiones:', error);
        });
      
      // Obtener datos de conexiones recientes desde la API
      axios.get('/api/v2/conexiones-recientes')
        .then(response => {
          console.log('Respuesta de la API (conexiones recientes):', response.data);
          if (response.data && response.data.length > 0) {
            this.recentConnectionsData = response.data;
            console.log('Datos guardados en recentConnectionsData:', this.recentConnectionsData);
            setTimeout(() => {
              this.createRecentConnectionsChart();
            }, 100);
          } else {
            console.warn('La API devolvió un array vacío o un formato inesperado para conexiones recientes');
          }
        })
        .catch(error => {
          console.error('Error cargando datos de conexiones recientes:', error);
        });
      
      // Aquí se pueden cargar los datos para la pestaña de automatizaciones desde el controlador
      axios.get('/api/v2/automatizaciones')
        .then(response => {
          console.log('Respuesta de la API (automatizaciones):', response.data);
          if (response.data) {
            // Asigna los datos según la estructura esperada
            this.cronLinuxSummary = response.data.cronLinuxSummary || [];
            this.cronAccessSummary = response.data.cronAccessSummary || [];
            this.cronLinuxAutomatismos = response.data.cronLinuxAutomatismos || [];
            this.cronAccessAutomatismos = response.data.cronAccessAutomatismos || [];
            this.maxCronLinuxValue = Math.max(...this.cronLinuxSummary.map(item => item.ejecutados), 100);
            this.maxCronAccessValue = Math.max(...this.cronAccessSummary.map(item => item.ejecutados), 100);
          } else {
            console.warn('La API de automatizaciones devolvió un formato inesperado');
          }
        })
        .catch(error => {
          console.error('Error cargando datos de automatizaciones:', error);
        });
      
      // Finalizar el estado de carga
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    
    createHighConnectionChart() {
      console.log('Intentando crear gráfico de conexiones críticas...');
      if (!this.highConnectionData || this.highConnectionData.length === 0) {
        console.error('No hay datos para mostrar en el gráfico');
        return;
      }
      this.$nextTick(() => {
        if (!this.$refs.highConnectionChart) {
          console.error('No se encontró el elemento canvas para el gráfico');
          return;
        }
        if (this.highConnectionChart) {
          this.highConnectionChart.destroy();
        }
        const ctx = this.$refs.highConnectionChart.getContext('2d');
        const labels = this.highConnectionData.map(item => item.fecha);
        const data = this.highConnectionData.map(item => item.conexiones);
        const backgroundColors = this.highConnectionData.map(item => {
          if (item.porcentaje >= 90) return 'rgba(245, 54, 92, 0.8)';
          if (item.porcentaje >= 85) return 'rgba(251, 99, 64, 0.8)';
          return 'rgba(251, 177, 64, 0.8)';
        });
        const borderColors = this.highConnectionData.map(item => {
          if (item.porcentaje >= 90) return 'rgb(245, 54, 92)';
          if (item.porcentaje >= 85) return 'rgb(251, 99, 64)';
          return 'rgb(251, 177, 64)';
        });
        try {
          const minValue = Math.min(...data) * 0.9;
          const maxValue = Math.max(...data) * 1.1;
          this.highConnectionChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: labels,
              datasets: [{
                label: 'Total Conexiones',
                data: data,
                backgroundColor: backgroundColors,
                borderColor: borderColors,
                borderWidth: 1,
                borderRadius: 6,
                maxBarThickness: 50,
                minBarLength: 5
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                title: {
                  display: true,
                  text: 'Conexiones críticas (>80% de máximo)',
                  font: {
                    size: 16,
                    weight: 'bold'
                  },
                  padding: {
                    top: 10,
                    bottom: 20
                  }
                },
                legend: { display: false },
                tooltip: {
                  callbacks: {
                    label: function(context) {
                      return context.raw + ' conexiones';
                    },
                    title: function(tooltipItems) {
                      return 'Fecha: ' + tooltipItems[0].label;
                    }
                  }
                }
              },
              scales: {
                y: {
                  beginAtZero: false,
                  min: minValue,
                  max: maxValue,
                  title: {
                    display: true,
                    text: 'Número de Conexiones',
                    font: { weight: 'bold' }
                  }
                },
                x: {
                  title: {
                    display: true,
                    text: 'Fecha',
                    font: { weight: 'bold' }
                  }
                }
              },
              animation: { duration: 1000, easing: 'easeOutQuart' }
            }
          });
          console.log('Gráfico creado exitosamente:', this.highConnectionChart);
        } catch (error) {
          console.error('Error al crear el gráfico:', error);
        }
      });
    },
    
    createConnectionTrendsChart() {
      console.log('Creando gráfico de evolución de conexiones...');
      if (!this.connectionTrendsData || this.connectionTrendsData.length === 0) {
        console.error('No hay datos para mostrar en el gráfico de tendencias');
        return;
      }
      this.$nextTick(() => {
        if (!this.$refs.connectionTrendsChart) {
          console.error('No se encontró el elemento canvas para el gráfico de tendencias');
          return;
        }
        if (this.connectionTrendsChart) {
          this.connectionTrendsChart.destroy();
        }
        const ctx = this.$refs.connectionTrendsChart.getContext('2d');
        const labels = this.connectionTrendsData.map(item => item.fecha);
        const totalData = this.connectionTrendsData.map(item => item.total);
        const activasData = this.connectionTrendsData.map(item => item.activas);
        const idleData = this.connectionTrendsData.map(item => item.idle);
        try {
          this.connectionTrendsChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: labels,
              datasets: [
                {
                  label: 'Total Conexiones',
                  data: totalData,
                  borderColor: '#5e72e4',
                  backgroundColor: 'rgba(94, 114, 228, 0.1)',
                  borderWidth: 2,
                  fill: false,
                  tension: 0.4
                },
                {
                  label: 'Conexiones Activas',
                  data: activasData,
                  borderColor: '#2dce89',
                  backgroundColor: 'rgba(45, 206, 137, 0.1)',
                  borderWidth: 2,
                  fill: false,
                  tension: 0.4
                },
                {
                  label: 'Conexiones Idle',
                  data: idleData,
                  borderColor: '#fb6340',
                  backgroundColor: 'rgba(251, 99, 64, 0.1)',
                  borderWidth: 2,
                  fill: false,
                  tension: 0.4
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                title: {
                  display: true,
                  text: 'Evolución de Conexiones',
                  font: {
                    size: 16,
                    weight: 'bold'
                  },
                  padding: { top: 10, bottom: 20 }
                },
                tooltip: { mode: 'index', intersect: false }
              },
              scales: {
                y: {
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: 'Número de Conexiones',
                    font: { weight: 'bold' }
                  }
                },
                x: {
                  title: {
                    display: true,
                    text: 'Fecha',
                    font: { weight: 'bold' }
                  }
                }
              },
              interaction: {
                mode: 'nearest',
                axis: 'x',
                intersect: false
              }
            }
          });
          console.log('Gráfico de tendencias creado exitosamente');
        } catch (error) {
          console.error('Error al crear el gráfico de tendencias:', error);
        }
      });
    },
    
    createRecentConnectionsChart() {
      console.log('Creando gráfico de conexiones recientes...');
      if (!this.recentConnectionsData || this.recentConnectionsData.length === 0) {
        console.error('No hay datos para mostrar en el gráfico de conexiones recientes');
        return;
      }
      this.$nextTick(() => {
        if (!this.$refs.recentConnectionsChart) {
          console.error('No se encontró el elemento canvas para el gráfico de conexiones recientes');
          return;
        }
        if (this.recentConnectionsChart) {
          this.recentConnectionsChart.destroy();
        }
        const ctx = this.$refs.recentConnectionsChart.getContext('2d');
        const labels = this.recentConnectionsData.map(item => `${item.fecha} ${item.hora}`);
        const totalData = this.recentConnectionsData.map(item => item.conexiones);
        const activasData = this.recentConnectionsData.map(item => item.activas);
        const idleData = this.recentConnectionsData.map(item => item.idle);
        try {
          this.recentConnectionsChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: labels,
              datasets: [
                {
                  label: 'Total Conexiones',
                  data: totalData,
                  borderColor: '#5e72e4',
                  backgroundColor: 'rgba(94, 114, 228, 0.1)',
                  borderWidth: 2,
                  fill: false,
                  tension: 0.4
                },
                {
                  label: 'Conexiones Activas',
                  data: activasData,
                  borderColor: '#2dce89',
                  backgroundColor: 'rgba(45, 206, 137, 0.1)',
                  borderWidth: 2,
                  fill: false,
                  tension: 0.4
                },
                {
                  label: 'Conexiones Idle',
                  data: idleData,
                  borderColor: '#fb6340',
                  backgroundColor: 'rgba(251, 99, 64, 0.1)',
                  borderWidth: 2,
                  fill: false,
                  tension: 0.4
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                title: {
                  display: true,
                  text: 'Historial de Conexiones (30 días)',
                  font: {
                    size: 16,
                    weight: 'bold'
                  },
                  padding: { top: 10, bottom: 20 }
                },
                tooltip: { mode: 'index', intersect: false },
                legend: { position: 'top' }
              },
              scales: {
                y: {
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: 'Número de Conexiones',
                    font: { weight: 'bold' }
                  }
                },
                x: {
                  ticks: { maxRotation: 45, minRotation: 45 },
                  title: {
                    display: true,
                    text: 'Fecha y Hora',
                    font: { weight: 'bold' }
                  }
                }
              },
              interaction: {
                mode: 'nearest',
                axis: 'x',
                intersect: false
              }
            }
          });
          console.log('Gráfico de conexiones recientes creado exitosamente');
        } catch (error) {
          console.error('Error al crear el gráfico de conexiones recientes:', error);
        }
      });
    },
    
    // Método de prueba para verificar si Chart.js funciona
    testChart() {
      console.log('Probando gráfico básico...');
      this.$nextTick(() => {
        if (!this.$refs.highConnectionChart) {
          console.error('No se encontró el elemento canvas para la prueba');
          return;
        }
        if (this.highConnectionChart) {
          this.highConnectionChart.destroy();
        }
        const ctx = this.$refs.highConnectionChart.getContext('2d');
        this.highConnectionChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Rojo', 'Azul', 'Amarillo', 'Verde', 'Morado'],
            datasets: [{
              label: 'Mi gráfico de prueba',
              data: [12, 19, 3, 5, 2],
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)'
              ],
              borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)'
              ],
              borderWidth: 1
            }]
          },
          options: {
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });
        console.log('Gráfico de prueba creado');
      });
    }
  },
  mounted() {
    if (typeof Chart === 'undefined') {
      console.error('Chart.js no está disponible');
    } else {
      console.log('Chart.js está disponible:', Chart.version);
    }
    this.loadDashboardData();
    // Para pruebas se puede activar el método testChart si es necesario:
    // setTimeout(() => this.testChart(), 1000);
  },
  beforeUnmount() {
    if (this.highConnectionChart) {
      this.highConnectionChart.destroy();
    }
    if (this.connectionTrendsChart) {
      this.connectionTrendsChart.destroy();
    }
    if (this.recentConnectionsChart) {
      this.recentConnectionsChart.destroy();
    }
  },
  watch: {
    activeTab(newValue) {
      if (newValue === 'conexiones' && !this.isLoading) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.createHighConnectionChart();
            this.createConnectionTrendsChart();
            this.createRecentConnectionsChart();
          }, 100);
        });
      }
    }
  }
};
</script>

<style scoped>
.chart-simulation {
  display: flex;
  align-items: flex-end;
  height: 150px;
  margin-top: 20px;
  gap: 10px;
}

.chart-simulation .bar {
  flex: 1;
  min-height: 20px;
  border-radius: 4px 4px 0 0;
  transition: height 0.3s ease;
}

/* Estilos para gráficos horizontales */
.chart-simulation.horizontal {
  flex-direction: column;
  height: auto;
  gap: 15px;
}

.bar-group {
  display: flex;
  align-items: center;
  width: 100%;
}

.bar-label {
  width: 100px;
  text-align: right;
  padding-right: 10px;
  font-size: 0.875rem;
}

.bar-container {
  flex: 1;
  height: 25px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.bar.horizontal {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 8px;
  color: white;
  font-size: 0.875rem;
  border-radius: 4px;
  transition: width 0.3s ease;
}

/* Nuevos estilos para mejorar la apariencia del gráfico */
.chart-container {
  position: relative;
  width: 100%;
  min-height: 300px;
}
</style>
